import React, { Component } from 'react';
import { MLInput, MLTextArea } from '../../Components';
import '../../Styles/css/maintenance.css';  //maintenance page changes-allowedemails

class RegisterViewContainer extends Component {

    constructor(props) {
        super();
        this.state = {
            firstname: "",
            lastname: "",
            jobtitle: "",
            company: "",
            email: "",
            bacontact: "",
            comment: "",
            isSubmited: false,
            msg_success: "",
            msg_error: "",
            status: 0,   
            message: "",
            maintenanceObj: [], //maintenance page changes
            allowedEmails : '' //maintenance page changes-allowedemails
        }
    }

    componentDidMount = async () => {
        console.log(`Envoirment ${process.env.REACT_APP_MODE}`)
        this.checkMaintenance(); //maintenance page changes
    }

    //maintenance page changes
    checkMaintenance = async() => {
        const formdata0={"period":0};
        await fetch(`${process.env.REACT_APP_API_BASE_URL}/wp-json/wpba/tem-auth/checkmaintenance`, {
            timeout: process.env.REACT_APP_DEFAULT_TIMEOUT,
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'Accept': 'application/json',
            },
            body: JSON.stringify(formdata0)
          })
          .then(res => res.json())
          .then(async response => {
            await this.setState({maintenanceObj:response});
            if(this.state.maintenanceObj.length > 0)
            {
                this.setState({message: this.state.maintenanceObj[0].status == 1 ? this.state.maintenanceObj[0].message : ''});
                this.setState({status: this.state.maintenanceObj[0].status == 1 ? this.state.maintenanceObj[0].status: 0});
                this.setState({allowedEmails: this.state.maintenanceObj[0].status == 1 ? this.state.maintenanceObj[0].allowemailids:''}); //maintenance page changes-allowedemails
            }
            else
            {
                this.setState({message:''});
                this.setState({status:0});
                this.setState({allowedEmails:''}); //maintenance page changes-allowedemails
            }
        })
    }

    shouldComponentUpdate(nextProps, nextState) {
        if (this.props.isLoading_auth === true && nextProps.isLoading_auth == false) {
            if (nextProps.isAuthenticated === true) {
                this.props.history.push(`/`);
            } else {
                if (nextProps.error !== "") {
                    this.setState({
                        msg_error: nextProps.error,
                        msg_success: ""
                    });
                } else {
                    this.setState({
                        msg_success: "Your request send to Admin`s approval successfully",
                        msg_error: ""
                    }, () => this._clear());
                }

            }
        }
        return true;
    }

    _hideMessage = () => {
        this.setState({ msg_error: "", msg_success: "" })
    }

    _onchange = (e, field) => {
        this.setState({
            [field]: e.target.value
        })
    }
   
    _onsubmit = (e) => {
        e.preventDefault();
        this.setState({
            isSubmited: true
        }, () => {
            if (this._validateFields()) {
                console.log(this.state);
                this.props.requestUserRegistration(this.state);
            }

        });

    }

    _checkErrorField = (field) => {
        let state = false;
        if (this.state[field] === "" && this.state.isSubmited) {
            state = true;
        }
        return state;
    }

    _validateFields() {
        let state = true;
        let ar = Object.keys(this.state);
        // console.log(ar);
        for (let i = 0; i < ar.length; i++) {
            if (ar[i] !== 'isSubmited' && ar[i] !== 'lastname'
                && ar[i] !== 'comment' && ar[i] !== 'msg_success' && ar[i] !== 'msg_error'
                && ar[i] !== 'status'  && ar[i] !==  'message'              //Registration fix for maintenance code
                && ar[i] !== 'maintenanceObj' && ar[i] !== 'allowedEmails'  //Registration fix for maintenance code
                && this.state[ar[i]] === "") {
                state = false;
                break;
            }
        }
        return state;
    }

    _clear = () => {
        this.setState({
            firstname: "",
            lastname: "",
            jobtitle: "",
            company: "",
            email: "",
            bacontact: "",
            comment: "",
            isSubmited: false,
        })
    }

    _backToLogin = () => {
        this.props.history.push(`/login`);
    }

    render = () => {
        const {maintenanceObj} = this.state; //maintenance page changes
        return (
            <div className="container-fluid login-container">
                    <div className="row">
                        <div className="col-md-6 login-column login-column--primary">
                            <div className="column-inner">
                                <img src="./assets/logo-white.svg" width="200" className="mb-4"/>
                                <h1>Bridge 5G Exchange</h1> {/*Comments: 5G Initial Code Changes, Modified By: <Asar>, Date Modified: <2020-01-22>*/}
                                <h3 className="text-thin">Discover 5G globally</h3>
                            </div>
                        </div>
                        <div className="col-md-6 login-column login-column--secondary">
                            <div className="column-inner">
                                {(this.state.msg_error !== "") && (
                                    <div className="alert alert-danger alert-dismissible fade show" role="alert">
                                        {this.state.msg_error}
                                        <button type="button" className="close" data-dismiss="alert" aria-label="Close" onClick={this._hideMessage}>
                                            <span aria-hidden="true">&times;</span>
                                        </button>
                                    </div>
                                )}
                                {(this.state.msg_success !== "") && (
                                    <div className="alert alert-success alert-dismissible fade show" role="alert">
                                        {this.state.msg_success}
                                        <button type="button" className="close" data-dismiss="alert" aria-label="Close" onClick={this._hideMessage}>
                                            <span aria-hidden="true">&times;</span>
                                        </button>
                                    </div>
                                )}
                                
                                    {/*maintenance page changes*/} {/*maintenance page changes-allowedemails - css added*/}
                                  
                                    <p className="maintenance-textcolor maintenance-textalign">{(maintenanceObj.length>0) ? '5G Exchange portal under maintenance!' : '' }</p>
                                    <p className="maintenance-textcolor"> {(maintenanceObj.length>0) ?  maintenanceObj[0].message : '' } </p>
                                    {(maintenanceObj.length == 0) ? this._renderRegister(this.props.isLoading_auth) : '' } 
                                   
                                    {/*maintenance page changes*/}
                            </div>
                        </div>
                    </div>
            </div>

        );
    };

    _renderRegister = loading => {
        return (
            <form onSubmit={this._onsubmit}> 
                <b>Bridge 5G Exchange Access Request</b><br /> {/*Comments: 5G Initial Code Changes, Modified By: <Asar>, Date Modified: <2020-01-22>*/}
                <div className="form-group">
                    {/*<p>
                        Access to the site will only be granted to members of Bridge Alliance.
                        To help us verify your identity, please use your business email address and
                        let us know who your contact person in Bridge Alliance is.
                    </p>*/}
                    <p>
                    Access to the site will only be granted to members of Bridge Alliance. <br/>To help us verify your identity, please use your <b>corporate</b> email address, as personal email addresses will not be approved. Do let us know who your contact person in Bridge Alliance is.
                    </p>
                </div>
                <div className="row">
                    <div className="col-md-6">
                        <div className="form-group">
                            <MLInput
                                placeholder={"first_name"}
                                className={`form-control ${this._checkErrorField('firstname') ? "is-invalid" : ""}`}
                                onChange={(e) => this._onchange(e, 'firstname')}
                                value={this.state.firstname}
                            />

                        </div>
                    </div>
                    <div className="col-md-6">
                        <div className="form-group">
                            <MLInput
                                placeholder={"last_name"}
                                className={`form-control`}
                                onChange={(e) => this._onchange(e, 'lastname')}
                                value={this.state.lastname}
                            />
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-6">
                        <div className="form-group">
                            <MLInput
                                placeholder={"job_title"}
                                className={`form-control ${this._checkErrorField('jobtitle') ? "is-invalid" : ""}`}
                                onChange={(e) => this._onchange(e, 'jobtitle')}
                                value={this.state.jobtitle}
                            />
                        </div>
                    </div>
                    <div className="col-md-6">
                        <div className="form-group">
                            <MLInput
                                placeholder={"company"}
                                className={`form-control ${this._checkErrorField('company') ? "is-invalid" : ""}`}
                                onChange={(e) => this._onchange(e, 'company')}
                                value={this.state.company}
                            />
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-6">
                        <div className="form-group">
                            <MLInput
                                placeholder={"email"}
                                className={`form-control ${this._checkErrorField('email') ? "is-invalid" : ""}`}
                                type={"email"}
                                onChange={(e) => this._onchange(e, 'email')}
                                value={this.state.email}
                            />
                        </div>
                    </div>
                    <div className="col-md-6">
                        <div className="form-group">
                            <MLInput
                                placeholder={"bridge_contact"}
                                className={`form-control ${this._checkErrorField('bacontact') ? "is-invalid" : ""}`}
                                onChange={(e) => this._onchange(e, 'bacontact')}
                                value={this.state.bacontact}
                            />
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-12">
                        <MLTextArea
                            placeholder={"comment"}
                            className={`form-control`}
                            onChange={(e) => this._onchange(e, 'comment')}
                            value={this.state.comment}
                        />
                    </div>
                </div>
                <div className="row mt-4">
                    <div className="col">
                    <button type="submit" className="btn btn-primary mr-4">Submit</button>
                    {
                    loading && 
                    <div className="ml-1 mr-3 spinner-border spinner-border-sm" role="status">
                        <span className="sr-only">Loading...</span>
                    </div>
                    }
                    <button type="button" className="btn btn-outline-primary mr-auto" onClick={this._backToLogin} >Back to Login</button>
                    </div>
                </div>
            </form>
        )
    }

}

export default RegisterViewContainer;